var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 9V3.9992C13.8 3.93605 13.7876 3.87351 13.7635 3.81517C13.7393 3.75683 13.7039 3.70382 13.6592 3.6592L11.1408 1.1408C11.0509 1.05076 10.9289 1.00011 10.8016 1H1.48C1.3527 1 1.23061 1.05057 1.14059 1.14059C1.05057 1.23061 1 1.3527 1 1.48V16.52C1 16.6473 1.05057 16.7694 1.14059 16.8594C1.23061 16.9494 1.3527 17 1.48 17H6.6",
    stroke: "#0073AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5986 3.71998V1.28318C10.5987 1.22725 10.6154 1.17259 10.6465 1.12611C10.6776 1.07963 10.7218 1.04341 10.7735 1.02202C10.8252 1.00062 10.8821 0.995017 10.9369 1.0059C10.9918 1.01679 11.0422 1.04368 11.0818 1.08318L13.7154 3.71678C13.7553 3.75624 13.7826 3.80668 13.7937 3.86168C13.8048 3.91668 13.7993 3.97374 13.7778 4.02559C13.7563 4.07743 13.7199 4.12171 13.6732 4.15277C13.6265 4.18383 13.5715 4.20027 13.5154 4.19998H11.0786C10.9513 4.19998 10.8292 4.14941 10.7392 4.05939C10.6492 3.96938 10.5986 3.84729 10.5986 3.71998V3.71998Z",
    stroke: "#0073AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0982 14.6L11.0982 14.1L10.5982 14.1L8.69824 14.1L8.69824 11.9L10.5982 11.9L11.0982 11.9L11.0982 11.4L11.0982 10.2071L13.8911 13L11.0982 15.7929L11.0982 14.6Z",
    fill: "#0073AB",
    stroke: "#0073AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBtnIcon);
export default __webpack_public_path__ + "static/media/save-btn-icon.87050ea50d339472947dc276dbce8c32.svg";
export { ForwardRef as ReactComponent };